import { render, staticRenderFns } from "./ContinuousFilingEscalations.vue?vue&type=template&id=47faba12&scoped=true&"
import script from "./ContinuousFilingEscalations.vue?vue&type=script&lang=js&"
export * from "./ContinuousFilingEscalations.vue?vue&type=script&lang=js&"
import style0 from "./ContinuousFilingEscalations.vue?vue&type=style&index=0&id=47faba12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47faba12",
  null
  
)

export default component.exports